import { getBaseUrl } from '../lib/helpers'
import { TRACKING_API_URL } from './tracking-constants'
import type { ReqTrackingType, TrackingStatusType } from './types'


const statusCodeErrorPrefix = 'updateTrackingStatus status error code: '

class TrackingService {
  static trackingInstance: TrackingService | null = null

  static getInstance() {
    if (TrackingService.trackingInstance === null) {
      TrackingService.trackingInstance = new TrackingService()
    }

    return this.trackingInstance
  }

  async updateTrackingStatus(trackingStatus: TrackingStatusType) {
    try {
      const response = await fetch(
        `${getBaseUrl()}${TRACKING_API_URL}update`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(trackingStatus),
          credentials: 'omit'
        }
      )
      if (!response.ok) {
        throw Error(statusCodeErrorPrefix + response.status)
      }

      const data = await response.text()
      return data
    } catch (err) {
      if (err instanceof Error && err.message.startsWith(statusCodeErrorPrefix)) throw err
      console.log('updateTrackingStatus err: ' + err)
      return null
    }
  }

  async getTrackingInfo(reqTracking: ReqTrackingType, headers: Headers) {

    try {
      const response = await fetch(
        `${getBaseUrl()}${TRACKING_API_URL}publish`,
        {
          method: 'POST',
          body: JSON.stringify(reqTracking),
          headers: headers,
          credentials: 'omit'
        }
      )

      if (!response.ok) {
        throw Error(statusCodeErrorPrefix + response.status)
      }

      const data = await response.json()
      return data
    } catch (err) {
      if (err instanceof Error && err.message.startsWith(statusCodeErrorPrefix)) throw err
      console.log('getTrackingInfo err: ' + err)
      const message = err instanceof Error ? err.message : 'Unknown Error'
      throw Error('updateTrackingStatus err: ' + message)
    }
  }
}

export { TrackingService }
